import type { HTMLAttributes } from 'preact';
import cn from 'classnames';
import styles from './SkeletonText.module.scss';

export default function SkeletonText({
  class: className,
  ...rest
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span class={cn(styles.container, className)} {...rest}>
      &nbsp;
    </span>
  );
}
